import { AxiosResponse } from 'axios';
import { api } from './api.service';
import { PermissionModel } from '../models/permission.model';

class PermissionService {

  getAll(): Promise<AxiosResponse<{ data: PermissionModel[] }>> {
    const url = `/permissions`;
    return api.get<{ data: PermissionModel[] }>(url);
  }

  getUserPermissions(id: number): Promise<AxiosResponse<{ data: PermissionModel[] }>> {
    const url = `/permissions/${id}`;
    return api.get<{ data: PermissionModel[] }>(url);
  }

  createPermisson(
      id: number,
      data: {}
    ): Promise<AxiosResponse<{ data: PermissionModel }>> {
      const url = `/permissions/${id}`;
      return api.post<{ data: PermissionModel }>(url, data);
    }
  

}

export default new PermissionService();
